import createIcon from '../../createIcon';

/**
 * @component @name Grade
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTcuNzdMMTguMTggMjEuNUwxNi41NCAxNC40N0wyMiA5Ljc0TDE0LjgxIDkuMTNMMTIgMi41TDkuMTkgOS4xM0wyIDkuNzRMNy40NiAxNC40N0w1LjgyIDIxLjVMMTIgMTcuNzdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Grade = createIcon('Grade', [
  [
    'path',
    {
      d: 'M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z',
      key: '15w0m1',
    },
  ],
]);

export default Grade;
